import { notifyClientFetchSr } from '../api/checks'
import type { Resolvers } from '../generated/server/resolvers'

const SuitabilityResolvers: Resolvers = {
  Mutation: {
    sendClientSrNotification: async (_, { input }) => {
      return await notifyClientFetchSr(input)
    },
  },
}

export default SuitabilityResolvers
